import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { LockClock } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/auth.service';

export function SubscriptionExpiredPage() {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await authService.logout();
    } finally {
      navigate('/login', { replace: true });
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 540, width: '100%' }}>
        <CardContent>
          <Stack spacing={2} alignItems="center" textAlign="center">
            <LockClock sx={{ fontSize: 56, color: 'error.main' }} />
            <Typography variant="h5" fontWeight={700}>
              Subscription expired
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Your county&rsquo;s access to the platform has paused because the billing period has
              ended. Citizens cannot make payments and admin functions are unavailable until the
              service provider renews your subscription.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Please contact your service provider to renew. Once renewed, access is restored
              immediately — no data is lost.
            </Typography>
            <Button variant="outlined" onClick={logout}>
              Log out
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
